var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-top":"55px"}},[_c('spinner',{attrs:{"data":_vm.spinnerData}}),_c('all-feeds',{attrs:{"feeds":_vm.mainFeed,"feed-status":"true"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }